import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { SUPPORT_API } from '../components/support/supportConstants';

const BADGE_POLL_MS = 60000;

/**
 * Polls support ticket counts for agent nav badge (need_reply).
 */
export function useAgentSupportBadge(enabled = true) {
  const [needReplyCount, setNeedReplyCount] = useState(0);

  const refresh = useCallback(async () => {
    if (!enabled) return;
    try {
      const r = await axios.get(`${SUPPORT_API}/support/tickets`, {
        withCredentials: true,
        params: { page: 1, limit: 1, status: 'all' },
      });
      setNeedReplyCount(Number(r.data?.counts?.need_reply || 0));
    } catch {
      setNeedReplyCount(0);
    }
  }, [enabled]);

  useEffect(() => {
    if (!enabled) return undefined;
    refresh();
    const onVis = () => {
      if (document.visibilityState === 'visible') refresh();
    };
    document.addEventListener('visibilitychange', onVis);
    const iv = setInterval(() => {
      if (document.visibilityState === 'visible') refresh();
    }, BADGE_POLL_MS);
    return () => {
      document.removeEventListener('visibilitychange', onVis);
      clearInterval(iv);
    };
  }, [enabled, refresh]);

  return { needReplyCount, refresh };
}

export default useAgentSupportBadge;
